import React from "react"
import { Link } from "react-router-dom"
import { Body } from "components/Shell/Shell"
import { FieldError } from "./CreateAccount"
import { parseUrlQuery } from "utilities"
import { PARSE_PASSWORD_RESET_TOKEN, CHANGE_PASSWORD } from "requests"

export default class ChangePassword extends React.Component {
  state = {
    errors: {},
    token: null,
    tokenExpired: false,
    parsing: true,
    username: ""
  }
  componentDidMount = () => {
    const search = this.props.location.search
    const { token } = parseUrlQuery(search)
    if (!token) {
      this.props.history.replace("/auth")
    } else {
      this.setState({ token })
      this.parseToken(token)
    }
  }
  validate = () => {
    const password = this.password.value
    const confirmPassword = this.confirmPassword.value
    let errors = {}
    if (!password) {
      errors.password = "A password is required"
    } else if (password.length < 8) {
      errors.password = process.env.PASSWORD_CUSTOM_ERROR_TEXT || "Password must be at least 8 characters"
    }
    if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords must match"
    }
    if (Object.keys(errors).length > 0 && this.state.token !== null) {
      this.setState({ errors })
    } else {
      this.setState({ errors: {} })
      this.changePassword(password)
    }
  }
  parseToken = token => {
    PARSE_PASSWORD_RESET_TOKEN(
      token,
      ({username, expired}) => {
        this.setState({ username, parsing: false })
      },
      err => {
        console.error(err)
        if (err.code === "auth/resetTokenExpired") {
          this.setState({
            token: null,
            tokenExpired: true,
            parsing: false
          })
        } else {
          this.setGenericGlobalError()
        }
      }
    )
  }
  changePassword = password => {
    CHANGE_PASSWORD(
      { token: this.state.token, password },
      () => {
        this.props.history.replace('/auth?changed=true')
      },
      err => {
        console.error(err)
        if (err.code === "auth/passwordRequirementsNotMet") {
          this.setState(state => ({
            errors: {
              ...state.errors,
              submit: err.message
            }
          }))
        } else {
          this.setGenericGlobalError()
        }
      }
    )
  }
  setGenericGlobalError = () => {
    this.setState(state => ({
      errors: {
        ...state.errors,
        submit: `Oops, something went wrong. You can try submitting again \
later. If the problem persists please contact customer support.`
      }
    }))
  }
  render() {
    return (
      <Body className="login-redirector">
        {!this.state.parsing && (
          <div
            className={`admin-login-wrapper login-modal-new animated fadeInDown fast-animation`}
          >
            <div className="login-column" style={{ paddingTop: 95 }}>
              <div className="banner">Change Password</div>
              {this.state.tokenExpired ? (
                <FieldError>
                  This password link has expired, you can{" "}
                  <Link to="/auth?page=forgot">request a new one</Link>, or{" "}
                  <Link to="/auth">login here</Link>.
                </FieldError>
              ) : (
                <form className="login forgot-password">
                  <p className="description">
                    Please pick a new password for the account associated with
                    <strong>{` ${this.state.username}`}</strong>.
                  </p>
                  <div className="field">
                    <label>New Password</label>
                    <p className="description">
                      {process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE ? 
                        <span dangerouslySetInnerHTML={{__html: process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE}}></span>
                      :
                        'Password must be at least 8 characters'}
                    </p>
                    <input
                      type="password"
                      ref={ref => {
                        this.password = ref
                      }}
                      onKeyDown={this.checkEnter}
                      placeholder=""
                    />
                    <FieldError>{this.state.errors.password}</FieldError>
                  </div>
                  <div className="field">
                    <label>Confirm New Password</label>
                    <input
                      type="password"
                      ref={ref => {
                        this.confirmPassword = ref
                      }}
                      onKeyDown={this.checkEnter}
                      placeholder=""
                    />
                    <FieldError>{this.state.errors.confirmPassword}</FieldError>
                  </div>
                  <div className="button-wrapper create-wrapper">
                    <button
                      type="button"
                      className="btn-raised btn-light-primary submit"
                      onClick={this.validate}
                    >
                      SAVE CHANGES
                    </button>
                    <FieldError>{this.state.errors.submit}</FieldError>
                  </div>
                </form>
              )}
            </div>
          </div>
        )}
      </Body>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shell/Login/ChangePassword.js